import styled from 'styled-components';

export const AutoListContainer = styled.div`
    width: ${(props) => (props.width ? props.width : '100%')};
    border-bottom: ${(props) =>
        props.bBottom ? props.bBottom : '1px solid #dee2e6'};
    padding: ${({ padding }) => (padding ? padding : '6px 16px')};
`;
export const AutoListMainView = styled.div`
    flex-direction: ${(props) => (props.fDirection ? props.fDirection : 'row')};
    display: ${(props) => (props.display ? props.display : 'flex')};
    justify-content: ${(props) =>
        props.jContent ? props.jContent : 'space-between'};
    align-items: ${(props) => (props.aContent ? props.aContent : 'center')};
    overflow-x: ${(props) => props.overflowX};
    word-break: ${(props) => props.wordBreak};
`;
export const MultiDivRowView = styled.div`
    flex-direction: ${(props) => (props.fDirection ? props.fDirection : 'row')};
    display: ${(props) => (props.display ? props.display : 'flex')};
`;
export const CustomText = styled.span`
    background-color: ${(props) => props.bgColor};
    font-size: ${(props) => (props.fontSize ? props.fontSize : '10px')};
    // line-height: '20px';
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : 'AvenirNextWorld Bold'};
    padding-top: ${(props) => (props.paddingTop ? props.paddingTop : '2px')};
    color: ${(props) => props.color};
`;
export const BrandContainer = styled.div`
    font-size: 13px;
    color: #000000;
    letter-spacing: -0.1px;
`;
export const BrandHeader = styled.span`
    font-family: 'AvenirNextWorld Demi';
`;
export const BrandName = styled.span`
    font-family: 'AvenirNextWorld Regular';
`;
